"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var TabPane_1 = tslib_1.__importDefault(require("./TabPane"));
var helper_1 = require("../../utils/helper");
var context_1 = require("./context");
var theme_1 = require("../../utils/theme");
var TabPaneElementType = (h(TabPane_1.default, null)).type;
var Tabs = (function (_super) {
    tslib_1.__extends(Tabs, _super);
    function Tabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentActiveId: _this.props.defaultActiveId
        };
        _this.activeTabItemRef = React.createRef();
        _this.indicatorRef = React.createRef();
        _this.containerRef = React.createRef();
        _this.handleTabBarClick = function (id) {
            _this.setState({ currentActiveId: id });
            _this.props.onChange(id);
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, forceActiveId = _a.activeId, tabBarStyle = _a.tabBarStyle, tabBarItemStyle = _a.tabBarItemStyle, indicatorStyle = _a.indicatorStyle, alignment = _a.alignment, activeItemStyle = _a.activeItemStyle;
            var stateActiveId = _this.state.currentActiveId;
            var activeId = forceActiveId || stateActiveId;
            var classes = classNames(prefixCls, className);
            var tabBarContent = React.Children.map(children, function (child) {
                var _a;
                if (child.type !== TabPaneElementType) {
                    return null;
                }
                var _b = child.props, id = _b.id, tab = _b.tab, icon = _b.icon, activeIcon = _b.activeIcon;
                var isActive = id === activeId;
                var tabBarItemClasses = classNames(prefixCls + "-bar-item", (_a = {},
                    _a[prefixCls + "-bar-item-active"] = isActive,
                    _a));
                var itemStyle = tslib_1.__assign(tslib_1.__assign({}, tabBarItemStyle), (isActive ? activeItemStyle : null));
                var effectiveIcon = isActive ? activeIcon || icon : icon;
                return (h("li", { className: tabBarItemClasses, style: itemStyle, key: id, onClick: function () { return _this.handleTabBarClick(id); }, ref: isActive ? _this.activeTabItemRef : function () { return null; } },
                    effectiveIcon ?
                        typeof effectiveIcon === 'string' ?
                            h("span", { className: classNames(prefixCls + "-icon"), style: { backgroundImage: "url(" + effectiveIcon + ")" } })
                            : effectiveIcon
                        : null,
                    tab));
            });
            var tabBarClasses = classNames(prefixCls + "-bar", prefixCls + "-bar-" + alignment);
            var contentClasses = classNames(prefixCls + "-content");
            return (h("div", { className: classes, style: style },
                h("div", { style: { position: 'relative' } },
                    h("ul", { className: tabBarClasses, style: tabBarStyle }, tabBarContent),
                    h("div", { className: classNames(prefixCls + "-indicator"), style: indicatorStyle, ref: _this.indicatorRef })),
                h("div", { className: contentClasses, ref: _this.containerRef },
                    h(context_1.ActiveTabIdContext.Provider, { value: activeId }, children))));
        };
        return _this;
    }
    Tabs.prototype.updateIndicator = function (skipAnimation) {
        if (skipAnimation === void 0) { skipAnimation = false; }
        var activeItemDom = this.activeTabItemRef.current;
        var indicatorDom = this.indicatorRef.current;
        if (!activeItemDom || !indicatorDom) {
            return;
        }
        var targetLeft = activeItemDom.offsetLeft, targetWidth = activeItemDom.offsetWidth;
        indicatorDom.style.left = targetLeft + "px";
        indicatorDom.style.width = targetWidth + "px";
        if (skipAnimation) {
            indicatorDom.style.transition = 'none';
            setTimeout(function () {
                indicatorDom.style.removeProperty('transition');
            }, 0);
        }
    };
    Tabs.prototype.componentDidUpdate = function () {
        this.updateIndicator();
    };
    Tabs.prototype.componentDidMount = function () {
        this.updateIndicator(true);
    };
    Tabs.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Tabs;
}(React.Component));
exports.default = Tabs;
Tabs.defaultProps = {
    prefixCls: 'dui-m-tabs',
    onChange: helper_1.emptyFn,
    defaultActiveId: '',
    alignment: 'center',
};
Tabs.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    activeId: PropTypes.string,
    defaultActiveId: PropTypes.string,
    onChange: PropTypes.func,
    tabBarStyle: PropTypes.object,
    tabBarItemStyle: PropTypes.object,
    activeItemStyle: PropTypes.object,
    indicatorStyle: PropTypes.object,
    alignment: PropTypes.oneOf(['center', 'left', 'right']),
};
